import React from "react";
import { Link } from "react-router-dom";

export function FreePreviewBanner({ grouped }) {
  if (!grouped.preview_limits) return null;
  const pl = grouped.preview_limits;
  return (
    <div
      data-testid="signals-free-banner"
      className="mb-4 p-4 border border-mod-soft bg-mod-soft rounded-sm flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
    >
      <div className="text-sm">
        <div className="font-mono text-[10px] uppercase tracking-widest text-mod mb-1">
          Free preview · You're seeing {grouped.short_term.length}/{pl.total_short_term_available} short-term, {grouped.long_term.length}/{pl.total_long_term_available} long-term, {grouped.fresh_today.length}/{pl.total_fresh_available} fresh
        </div>
        <div className="text-primary-fg">
          Unlock <span className="font-semibold">all {pl.total_long_term_available + pl.total_short_term_available} active breakouts</span> + Closed history + Target/SL alerts on every position.
        </div>
      </div>
      <Link
        to="/pricing"
        data-testid="signals-upgrade-btn"
        className="px-4 py-2 rounded-sm font-mono text-[10px] uppercase tracking-widest hover:opacity-90 transition shrink-0"
        style={{ background: "hsl(var(--text-primary))", color: "hsl(var(--bg))" }}
      >
        Upgrade · ₹5 trial
      </Link>
    </div>
  );
}

export function SignalsSubTabs({ signalsView, setSignalsView, counts, istToday }) {
  const tabs = [
    { k: "active", label: "Active", count: counts.active, hint: "Tracked until Target / SL / Exit hit" },
    { k: "fresh", label: "Fresh", count: counts.fresh, hint: "Breakout candle within the last 3 trading days" },
    { k: "closed", label: "Closed", count: counts.closed, hint: "Target / SL / Exit history" },
  ];
  const hint =
    signalsView === "active"
      ? "/// Signals persist until Target or SL hits"
      : signalsView === "fresh"
        ? `/// New breakouts detected on ${istToday || "today"}`
        : "/// History of completed trades";
  return (
    <div className="flex items-center gap-2 mb-5 border-b border-subtle pb-3 flex-wrap">
      {tabs.map((t) => (
        <button
          key={t.k}
          type="button"
          data-testid={`signals-subtab-${t.k}`}
          onClick={() => setSignalsView(t.k)}
          title={t.hint}
          className={
            "px-3 py-1.5 border border-subtle rounded-sm text-[10px] font-mono uppercase tracking-widest transition flex items-center gap-2 " +
            (signalsView === t.k
              ? (t.k === "closed"
                  ? "bg-neg-soft border-neg-soft text-neg"
                  : t.k === "fresh"
                    ? "bg-pos-soft border-pos-soft text-pos"
                    : "bg-mod-soft border-mod-soft text-mod")
              : "text-secondary-fg hover:bg-surface-hover hover:text-primary-fg")
          }
        >
          {t.label}
          <span className="font-mono tabular-nums">{t.count}</span>
        </button>
      ))}
      <div className="text-[10px] font-mono uppercase tracking-widest text-muted-fg ml-2">{hint}</div>
    </div>
  );
}
